"use client";

import { PencilIcon } from "@heroicons/react/24/solid";
import { useEffect, useState } from "react";

import { useLang } from "@/hooks/use-lang";

import { ArticleListData } from "../../services/article-list";
import { ArticleCard } from "./ArticleCard";
import { Pagination } from "./Pagination";

const PAGE_SIZE = 10;
export const ArticleList = ({ articles }: { articles: ArticleListData }) => {
  const totalPages = Math.ceil(articles.length / PAGE_SIZE);
  const { lang } = useLang();
  const [currentPage, setCurrentPage] = useState(1);
  const [currentArticles, setCurrentArticles] = useState<ArticleListData>([]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * PAGE_SIZE;
    const endIndex = startIndex + PAGE_SIZE;
    setCurrentArticles(articles.slice(startIndex, endIndex));
  }, [currentPage, articles]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    const myContent = document.querySelector("#my-content");
    if (myContent) {
      myContent.scrollTop = 0;
    }
  };

  return (
    <div
      data-testid="article-list"
      className="flex flex-col items-center gap-4 @sm:gap-7 @3xl:gap-5"
    >
      {articles.length > 0 ? (
        <>
          {currentArticles.map((article, index) => (
            <ArticleCard key={index} lang={lang} index={index} {...article} />
          ))}

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </>
      ) : (
        <NoDataView />
      )}
    </div>
  );
};

const NoDataView = () => {
  const { t } = useLang();
  return (
    <div
      className="flex h-40 w-full items-center justify-center gap-2 bg-white shadow @lg:rounded-xl"
      data-testid="no-data-view"
    >
      <PencilIcon className="h-4 w-4 text-zinc-900" />
      <p className="text-lg font-bold text-zinc-900">{t.blog.noData}</p>
    </div>
  );
};
